export default __webpack_public_path__ + "static/media/blog01.e3ac45cf.jpg";